const SkeletonTestimonial = () => (
  <div className="testimonial skeleton-testimonial">
    <div className="client__avatar">
      <div className="skeleton shimmer skeleton--avatar" />
    </div>
    <div className="skeleton shimmer skeleton--name" />
    <div className="skeleton shimmer skeleton--review" />
    <div className="skeleton shimmer skeleton--review skeleton--review-short" />
  </div>
);
export default SkeletonTestimonial;
